<input type="text" id="bareDeChargement" name="bareDeChargement" value="false" style="display: none;">
<div class="row" *ngIf="!etudiant">
    <p> Echangez en direct avec un conseiller de la Caf sans vous déplacer {{horaire}} (appels possibles depuis la France et les DOM | service gratuit + prix d'appel). </p>           
</div>
<div class="row" *ngIf="etudiant">
    <p>Echangez en direct avec un conseiller sur une ligne téléphonique dédiée du lundi au vendredi de 9h à 19h30 (appels possibles depuis la France et les DOM | service gratuit + prix d'appel).</p>           
</div>

<div clas="row">
    <div class="text-center">
        <a class="btn btn-primary-cnaf espacement" (click)="appelerCaf()">Appeler ma Caf</a>      
    </div>
</div>